import React from "react";
import { Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import "react-resizable/css/styles.css";
import "./Home.css";
import { useNavigate } from "react-router-dom";

import t1Logo from "../pictures/Titlep1.png";
import t2Logo from "../pictures/Titlep2.png";
import t3Logo from "../pictures/Titlep3.png";
import t4Logo from "../pictures/Titlep4.png";
import tt1Logo from "../pictures/Title1.png";
import tt2Logo from "../pictures/Title2.png";
import tt3Logo from "../pictures/Title3.png";
import tt4Logo from "../pictures/Title4.png";
import tt5Logo from "../pictures/Title5.png";
import tt6Logo from "../pictures/Title6.png";
import tt7Logo from "../pictures/Title7.png";
import tt8Logo from "../pictures/Title8.png";
import tt9Logo from "../pictures/Title9.png";
import tt10Logo from "../pictures/Title10.png";
import tt11Logo from "../pictures/Title11.png";
import tt12Logo from "../pictures/Title12.png";
import tt13Logo from "../pictures/Title13.png";
import tt14Logo from "../pictures/Title14.png";
import tt15Logo from "../pictures/Title15.png";
import tt16Logo from "../pictures/Title16.png";
import tt17Logo from "../pictures/Title17.png";
import tt18Logo from "../pictures/Title18.png";
import tt19Logo from "../pictures/Title19.png";
import tt20Logo from "../pictures/Title20.png";

const ResponsiveGridLayout = WidthProvider(Responsive);

const widgets = [
  { key: "t1", title: "T1", icon: t1Logo },
  { key: "t2", title: "T2", icon: t2Logo },
  { key: "t3", title: "T3", icon: t3Logo },
  { key: "t4", title: "T4", icon: t4Logo },
];

const widgets2 = [
  { key: "t1", title: "TT1", icon: tt1Logo },
  { key: "t2", title: "TT2", icon: tt2Logo },
  { key: "t3", title: "TT3", icon: tt3Logo },
  { key: "t4", title: "TT4", icon: tt4Logo },
  { key: "t5", title: "TT5", icon: tt5Logo },
  { key: "t6", title: "TT6", icon: tt6Logo },
  { key: "t7", title: "TT7", icon: tt7Logo },
  { key: "t8", title: "TT8", icon: tt8Logo },
  { key: "t9", title: "TT9", icon: tt9Logo },
  { key: "t10", title: "TT10", icon: tt10Logo },
  { key: "t11", title: "TT11", icon: tt11Logo },
  { key: "t12", title: "TT12", icon: tt12Logo },
  { key: "t13", title: "TT13", icon: tt13Logo },
  { key: "t14", title: "TT14", icon: tt14Logo },
  { key: "t15", title: "TT15", icon: tt15Logo },
  { key: "t16", title: "TT16", icon: tt16Logo },
  { key: "t17", title: "TT17", icon: tt17Logo },
  { key: "t18", title: "TT18", icon: tt18Logo },
  { key: "t19", title: "TT19", icon: tt19Logo },
  { key: "t20", title: "TT20", icon: tt20Logo },
];

// Dynamically generate layout
const layout = widgets.map((widget, index) => ({
  i: widget.key,
  x: 0,
  y: index,
  w: 1,
  h: 1,
}));

const layout2 = widgets2.map((widget2, index) => ({
  i: widget2.key,
  x: 0,
  y: index,
  w: 1,
  h: 1,
}));

export default function Title() {
  const navigate = useNavigate();

  const breakpoints = { lg: 920, sm: 0 };
  const cols = { lg: 1, sm: 1 };

  const layouts = {
    lg: layout,
    sm: layout.map(item => ({ ...item, x: 0, w: 1 })),
  };

  const layouts2 = {
    lg: layout2,
    sm: layout2.map(item => ({ ...item, x: 0, w: 1 })),
  };

  const handleClick = (url) => {
    if (url.startsWith("http")) {
      window.open(url, "_blank", "noopener,noreferrer");
    } else {
      navigate(url);
    }
  };

  return (
    <div className="home-container-agent">
      <div className="grid-wrapper">
        <ResponsiveGridLayout
          className="layout-title"
          layouts={layouts}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={1300}
          isResizable={false}
          isDraggable={false}
        >
          {widgets.map((widget) => (
            <div
              key={widget.key}
              className="widget-card"
            >
              <img src={widget.icon} alt={widget.title} className="widget-icon-title" />
            </div>
          ))}
        </ResponsiveGridLayout>
        <ResponsiveGridLayout
          className="layout-title2"
          layouts={layouts2}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={1550}
          isResizable={false}
          isDraggable={false}
        >
          {widgets2.slice(0, 5).map((widget2) => (
            <div
              key={widget2.key}
              className="widget-card2"
            >
              <img src={widget2.icon} alt={widget2.title} className="widget-icon-title" />
            </div>
          ))}
        </ResponsiveGridLayout>
        <ResponsiveGridLayout
          className="layout-title2"
          layouts={layouts2}
          breakpoints={breakpoints}
          cols={cols}
          rowHeight={2100}
          isResizable={false}
          isDraggable={false}
        >
          {widgets2.slice(5).map((widget2) => (
            <div
              key={widget2.key}
              className="widget-card2"
            >
              <img src={widget2.icon} alt={widget2.title} className="widget-icon-title" />
            </div>
          ))}
        </ResponsiveGridLayout>
      </div>
    </div>
  );
}
